import { useQuery } from "@tanstack/react-query";

import { PRACTICE_MANAGEMENT_ENDPOINTS, getPracticeManagementPorkParameters } from "services";

import { PRACTICE_MANAGEMENT, PRACTICE_MANAGEMENT_PORK_PARAMETERS } from "consts";

export const usePracticeManagementPorkParameters = (country: PracticeManagement.CountryCode = "global") =>
  useQuery({
    queryKey: [PRACTICE_MANAGEMENT, PRACTICE_MANAGEMENT_PORK_PARAMETERS, country],
    // Country-only resource: one row, and no domain-specific key, so the endpoint path stands in as the editing key
    queryFn: async () => {
      const parameters = await getPracticeManagementPorkParameters(country);
      return {
        ...parameters,
        editingKey: PRACTICE_MANAGEMENT_ENDPOINTS.PORK_PARAMETERS,
      };
    },
    staleTime: 1000 * 60 * 60, // 1h
    gcTime: 1000 * 60 * 24, // 24h
  });
